export const CollpaseIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2.75" y="3.75" width="18.5" height="16.5" rx="2.25" stroke="#434343" strokeWidth="1.5"/>
            <line x1="9.6" y1="3.7998" x2="9.6" y2="20.7998" stroke="#434343" strokeWidth="1.2"/>
            <path d="M4.5 7.5H8" stroke="#434343" strokeWidth="1.2" strokeLinecap="round"/>
            <path d="M4.5 10H8" stroke="#434343" strokeWidth="1.2" strokeLinecap="round"/>
        </svg>
    );
};